import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(({ breakpoints, spacing }: Theme) => ({
  logo: {
    width: '100%',
    padding: `${spacing(4)} ${spacing(12)}`,

    [breakpoints.down('md')]: {
      display: 'none',
    },
  },
}));

export default useStyles;
